import React from 'react';
import { Link } from 'gatsby';
import logo from '../../content/assets/logo.png';
import { developersSiteUrl } from '../utils/localDevUrls';
import './Header.css';

class Header extends React.Component {
  state = {
    menuOpen: false,
    // Resolved on mount: gatsby build bakes SSR without window, so href must be set client-side.
    developersUrl: 'https://developers.soundcloud.com',
  };

  componentDidMount() {
    this.setState({ developersUrl: developersSiteUrl() });
  }

  toggleMenu = () => {
    this.setState(prev => ({ menuOpen: !prev.menuOpen }));
  };

  closeMenu = () => {
    this.setState({ menuOpen: false });
  };

  render() {
    const { menuOpen, developersUrl } = this.state;

    return (
      <header className="sc-header">
        <nav className="sc-nav">
          <a
            href="https://soundcloud.com/"
            className="sc-logo"
            title="Go to SoundCloud.com"
            aria-label="SoundCloud"
          >
            <img src={logo} alt="SoundCloud" width={170} height={22} />
          </a>
          <ul className={`sc-nav__links${menuOpen ? ' is-open' : ''}`}>
            <li>
              <a href={developersUrl} onClick={this.closeMenu}>
                Home
              </a>
            </li>
            <li>
              <Link to="/" className="sc-nav__current" onClick={this.closeMenu}>
                Blog
              </Link>
            </li>
            <li>
              <a
                href="https://soundcloud.com/you/apps"
                target="_blank"
                rel="noopener noreferrer"
                onClick={this.closeMenu}
              >
                Your Apps
              </a>
            </li>
            <li>
              <a
                href="https://soundcloud.com/jobs"
                target="_blank"
                rel="noopener noreferrer"
                onClick={this.closeMenu}
              >
                Jobs
              </a>
            </li>
          </ul>
          <button
            type="button"
            className="sc-nav__hamburger"
            aria-label="Open menu"
            aria-expanded={menuOpen}
            onClick={this.toggleMenu}
          >
            <span />
            <span />
            <span />
          </button>
        </nav>
      </header>
    );
  }
}

export default Header;
